import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "./Logo";

const links = [
  { href: "#simuladores", label: "Simuladores" },
  { href: "#galeria", label: "Galeria" },
  { href: "#eventos", label: "Eventos" },
  { href: "#depoimentos", label: "Depoimentos" },
  { href: "#contato", label: "Contato" },
];

export default function Navbar({ onOpenQuote }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-[100] transition-[padding,background-color,border-color] duration-300 ${
        scrolled ? "py-3 bg-black/70 backdrop-blur-xl border-b border-white/5" : "py-5 bg-transparent"
      }`}
      data-testid="site-navbar"
    >
      <div className="mx-auto max-w-[1400px] px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group -my-2 shrink-0" data-testid="nav-logo">
          <img
            src="https://customer-assets.emergentagent.com/job_racing-simulator-hub/artifacts/e53tel1d_ChatGPT%20Image%2015%20de%20jul.%20de%202026%2C%2010_03_10.png"
            alt="SIM EXPERIENCE"
            className="h-12 sm:h-14 md:h-16 w-12 sm:w-14 md:w-16 rounded-full object-cover group-hover:scale-105 transition-transform"
            style={{ filter: "drop-shadow(0 0 12px rgba(227,27,35,0.35)) drop-shadow(0 0 18px rgba(0,140,255,0.25))" }}
          />
          <div className="hidden md:block font-display font-black tracking-tight text-sm lg:text-base leading-none whitespace-nowrap">
            <span className="text-white">SIM</span>
            <span className="text-[#E31B23]">.</span>
            <span className="text-white">EXPERIENCE</span>
          </div>
        </Link>

        <nav className="hidden xl:flex items-center gap-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-xs uppercase tracking-[0.18em] text-neutral-300 hover:text-white transition-colors relative group whitespace-nowrap"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-[1px] w-0 bg-gradient-to-r from-[#E31B23] to-[#008CFF] group-hover:w-full transition-[width] duration-300" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={onOpenQuote}
            className="hidden md:inline-flex items-center gap-2 rounded-full bg-[#E31B23] px-4 lg:px-5 py-2.5 text-xs lg:text-sm font-semibold text-white glow-red whitespace-nowrap"
            data-testid="nav-quote-btn"
          >
            Solicitar orçamento
            <ArrowUpRight className="w-4 h-4" />
          </button>
          <button
            className="xl:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="lg:hidden mt-3 mx-6 rounded-2xl glass-strong p-6"
            data-testid="nav-mobile-panel"
          >
            <ul className="space-y-4">
              {links.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="block text-lg font-display text-white hover:text-[#E31B23]"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <button
                  onClick={() => { setOpen(false); onOpenQuote(); }}
                  className="mt-2 w-full rounded-full bg-[#E31B23] py-3 text-white font-semibold glow-red"
                >
                  Solicitar orçamento
                </button>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
